import { sfVariant } from "@unlikelystudio/commerce-connector"

import { sfFetchWrapper } from "~/lib/shopify/utils/sf-fetch-wrapper"

export type IGetShopifyVariantById = Awaited<ReturnType<typeof getSfVariantById>>

export type IGetShopifyVariantByIdParams = Parameters<typeof get>

export async function getSfVariantById(...params: IGetShopifyVariantByIdParams) {
  const [input, options] = params

  return await get(
    {
      includeQuantityAvailable: true,
      ...input,
    },
    options
  )
}

const get = sfFetchWrapper(sfVariant)("product")
